module.exports = __webpack_public_path__ + "img/kayak_1413_1.de6569b4.jpg";